import React from 'react';
import {Link} from 'react-router-dom';
import {CATALOG_ROUTE} from '../../util/Constants';
import Seo from '../seo/Seo';

const Privacy = () => {
    /** Полный URL сайта магазина Лютика */
    const SITE_URL = 'lutica.ru';
    /** П. 1 — творительный падеж: «предпринимаемые …» (ИП / ООО и т.д.) */
    const OPERATOR_LEGAL_INSTRUMENTAL = 'плательщиком НПД Кулиевой Анастасией Михайловной (ИНН 784804153300)';
    /** П. 8.9 — родительный падеж: «прекращение деятельности …» */
    const OPERATOR_LEGAL_GENITIVE = 'плательщика НПД Кулиевой Анастасии Михайловны (ИНН 784804153300)';
    /** Контактный email Оператора для обращений по персональным данным */
    const OPERATOR_EMAIL = 'lutica.candle.shop@gmail.com';

    const privacyPageUrl = `${SITE_URL.replace(/\/$/, '')}/privacy`;

    return (
        <div className="pb-8 pt-2">
            <Seo
                title="Политика конфиденциальности"
                description="Политика обработки персональных данных интернет-магазина Lutica (152-ФЗ)."
                pathname="/privacy"
            />
            <Link to={CATALOG_ROUTE} className="text-sm font-medium text-pine-700 hover:underline">
                ← На главную
            </Link>
            <h1 className="mt-6 text-2xl font-semibold text-bark-900">
                Политика обработки персональных данных
            </h1>
            <div className="mt-6 space-y-6 text-sm leading-relaxed text-bark-700">
                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">1. Общие положения</h2>
                    <p>
                        Настоящая политика обработки персональных данных составлена в соответствии с требованиями
                        Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» (далее — Закон о
                        персональных данных) и определяет порядок обработки персональных данных и меры по
                        обеспечению безопасности персональных данных, предпринимаемые{' '}
                        {OPERATOR_LEGAL_INSTRUMENTAL} (далее — Оператор).
                    </p>
                    <p>
                        1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности
                        соблюдение прав и свобод человека и гражданина при обработке его персональных данных, в том
                        числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.
                    </p>
                    <p>
                        1.2. Настоящая политика Оператора в отношении обработки персональных данных (далее —
                        Политика) применяется ко всей информации, которую Оператор может получить о посетителях
                        веб-сайта {SITE_URL}.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">
                        2. Основные понятия, используемые в Политике
                    </h2>
                    <p>
                        2.1. Автоматизированная обработка персональных данных — обработка персональных данных с
                        помощью средств вычислительной техники.
                    </p>
                    <p>
                        2.2. Блокирование персональных данных — временное прекращение обработки персональных данных
                        (за исключением случаев, если обработка необходима для уточнения персональных данных).
                    </p>
                    <p>
                        2.3. Веб-сайт — совокупность графических и информационных материалов, а также программ для
                        ЭВМ и баз данных, обеспечивающих их доступность в сети интернет по сетевому адресу{' '}
                        {SITE_URL}.
                    </p>
                    <p>
                        2.4. Информационная система персональных данных — совокупность содержащихся в базах данных
                        персональных данных и обеспечивающих их обработку информационных технологий и технических
                        средств.
                    </p>
                    <p>
                        2.5. Обезличивание персональных данных — действия, в результате которых невозможно
                        определить без использования дополнительной информации принадлежность персональных данных
                        конкретному Пользователю или иному субъекту персональных данных.
                    </p>
                    <p>
                        2.6. Обработка персональных данных — любое действие (операция) или совокупность действий
                        (операций), совершаемых с использованием средств автоматизации или без использования таких
                        средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение,
                        уточнение (обновление, изменение), извлечение, использование, передачу (распространение,
                        предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных
                        данных.
                    </p>
                    <p>
                        2.7. Оператор — государственный орган, муниципальный орган, юридическое или физическое
                        лицо, самостоятельно или совместно с другими лицами организующие и/или осуществляющие
                        обработку персональных данных, а также определяющие цели обработки персональных данных,
                        состав персональных данных, подлежащих обработке, действия (операции), совершаемые с
                        персональными данными.
                    </p>
                    <p>
                        2.8. Персональные данные — любая информация, относящаяся прямо или косвенно к определенному
                        или определяемому Пользователю веб-сайта {SITE_URL}.
                    </p>
                    <p>
                        2.9. Персональные данные, разрешённые субъектом персональных данных для распространения, —
                        персональные данные, доступ неограниченного круга лиц к которым предоставлен субъектом
                        персональных данных путём дачи согласия на обработку персональных данных, разрешённых
                        субъектом персональных данных для распространения в порядке, предусмотренном Законом о
                        персональных данных (далее — персональные данные, разрешённые для распространения).
                    </p>
                    <p>2.10. Пользователь — любой посетитель веб-сайта {SITE_URL}.</p>
                    <p>
                        2.11. Предоставление персональных данных — действия, направленные на раскрытие
                        персональных данных определённому лицу или определённому кругу лиц.
                    </p>
                    <p>
                        2.12. Распространение персональных данных — любые действия, направленные на раскрытие
                        персональных данных неопределённому кругу лиц (передача персональных данных) или на
                        ознакомление с персональными данными неограниченного круга лиц, в том числе обнародование
                        персональных данных в средствах массовой информации, размещение в
                        информационно-телекоммуникационных сетях или предоставление доступа к персональным данным
                        каким-либо иным способом.
                    </p>
                    <p>
                        2.13. Трансграничная передача персональных данных — передача персональных данных на
                        территорию иностранного государства органу власти иностранного государства, иностранному
                        физическому или иностранному юридическому лицу.
                    </p>
                    <p>
                        2.14. Уничтожение персональных данных — любые действия, в результате которых персональные
                        данные уничтожаются безвозвратно с невозможностью дальнейшего восстановления содержания
                        персональных данных в информационной системе персональных данных и/или уничтожаются
                        материальные носители персональных данных.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">
                        3. Основные права и обязанности Оператора
                    </h2>
                    <p className="font-medium text-bark-800">3.1. Оператор имеет право:</p>
                    <ul className="list-disc space-y-2 pl-5">
                        <li>
                            получать от субъекта персональных данных достоверные информацию и/или документы,
                            содержащие персональные данные;
                        </li>
                        <li>
                            в случае отзыва субъектом персональных данных согласия на обработку персональных
                            данных, а также направления обращения с требованием о прекращении обработки
                            персональных данных, Оператор вправе продолжить обработку персональных данных без
                            согласия субъекта персональных данных при наличии оснований, указанных в Законе о
                            персональных данных;
                        </li>
                        <li>
                            самостоятельно определять состав и перечень мер, необходимых и достаточных для
                            обеспечения выполнения обязанностей, предусмотренных Законом о персональных данных и
                            принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено
                            Законом о персональных данных или другими федеральными законами.
                        </li>
                    </ul>
                    <p className="font-medium text-bark-800">3.2. Оператор обязан:</p>
                    <ul className="list-disc space-y-2 pl-5">
                        <li>
                            предоставлять субъекту персональных данных по его просьбе информацию, касающуюся
                            обработки его персональных данных;
                        </li>
                        <li>
                            организовывать обработку персональных данных в порядке, установленном действующим
                            законодательством РФ;
                        </li>
                        <li>
                            отвечать на обращения и запросы субъектов персональных данных и их законных
                            представителей в соответствии с требованиями Закона о персональных данных;
                        </li>
                        <li>
                            сообщать в уполномоченный орган по защите прав субъектов персональных данных по запросу
                            этого органа необходимую информацию в течение 10 дней с даты получения такого запроса;
                        </li>
                        <li>
                            публиковать или иным образом обеспечивать неограниченный доступ к настоящей Политике в
                            отношении обработки персональных данных;
                        </li>
                        <li>
                            принимать правовые, организационные и технические меры для защиты персональных данных от
                            неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования,
                            копирования, предоставления, распространения персональных данных, а также от иных
                            неправомерных действий в отношении персональных данных;
                        </li>
                        <li>
                            прекратить передачу (распространение, предоставление, доступ) персональных данных,
                            прекратить обработку и уничтожить персональные данные в порядке и случаях,
                            предусмотренных Законом о персональных данных;
                        </li>
                        <li>исполнять иные обязанности, предусмотренные Законом о персональных данных.</li>
                    </ul>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">
                        4. Основные права и обязанности субъектов персональных данных
                    </h2>
                    <p className="font-medium text-bark-800">4.1. Субъекты персональных данных имеют право:</p>
                    <ul className="list-disc space-y-2 pl-5">
                        <li>
                            получать информацию, касающуюся обработки его персональных данных, за исключением
                            случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту
                            персональных данных Оператором в доступной форме, и в них не должны содержаться
                            персональные данные, относящиеся к другим субъектам персональных данных, за исключением
                            случаев, когда имеются законные основания для раскрытия таких персональных данных.
                            Перечень информации и порядок её получения установлен Законом о персональных данных;
                        </li>
                        <li>
                            требовать от оператора уточнения его персональных данных, их блокирования или
                            уничтожения в случае, если персональные данные являются неполными, устаревшими,
                            неточными, незаконно полученными или не являются необходимыми для заявленной цели
                            обработки, а также принимать предусмотренные законом меры по защите своих прав;
                        </li>
                        <li>
                            выдвигать условие предварительного согласия при обработке персональных данных в целях
                            продвижения на рынке товаров, работ и услуг;
                        </li>
                        <li>
                            на отзыв согласия на обработку персональных данных, а также на направление требования о
                            прекращении обработки персональных данных;
                        </li>
                        <li>
                            обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в
                            судебном порядке неправомерные действия или бездействие Оператора при обработке его
                            персональных данных;
                        </li>
                        <li>на осуществление иных прав, предусмотренных законодательством РФ.</li>
                    </ul>
                    <p className="font-medium text-bark-800">4.2. Субъекты персональных данных обязаны:</p>
                    <ul className="list-disc space-y-2 pl-5">
                        <li>предоставлять Оператору достоверные данные о себе;</li>
                        <li>
                            сообщать Оператору об уточнении (обновлении, изменении) своих персональных данных.
                        </li>
                    </ul>
                    <p>
                        4.3. Лица, передавшие Оператору недостоверные сведения о себе, либо сведения о другом
                        субъекте персональных данных без согласия последнего, несут ответственность в соответствии с
                        законодательством РФ.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">5. Принципы обработки персональных данных</h2>
                    <p>
                        5.1. Обработка персональных данных осуществляется на законной и справедливой основе.
                    </p>
                    <p>
                        5.2. Обработка персональных данных ограничивается достижением конкретных, заранее
                        определённых и законных целей. Не допускается обработка персональных данных, несовместимая с
                        целями сбора персональных данных.
                    </p>
                    <p>
                        5.3. Не допускается объединение баз данных, содержащих персональные данные, обработка которых
                        осуществляется в целях, несовместимых между собой.
                    </p>
                    <p>5.4. Обработке подлежат только персональные данные, которые отвечают целям их обработки.</p>
                    <p>
                        5.5. Содержание и объём обрабатываемых персональных данных соответствуют заявленным целям
                        обработки. Не допускается избыточность обрабатываемых персональных данных по отношению к
                        заявленным целям их обработки.
                    </p>
                    <p>
                        5.6. При обработке персональных данных обеспечивается точность персональных данных, их
                        достаточность, а в необходимых случаях и актуальность по отношению к целям обработки
                        персональных данных. Оператор принимает необходимые меры и/или обеспечивает их принятие по
                        удалению или уточнению неполных или неточных данных.
                    </p>
                    <p>
                        5.7. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта
                        персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если
                        срок хранения персональных данных не установлен федеральным законом, договором, стороной
                        которого, выгодоприобретателем или поручителем по которому является субъект персональных
                        данных. Обрабатываемые персональные данные уничтожаются либо обезличиваются по достижении
                        целей обработки или в случае утраты необходимости в достижении этих целей, если иное не
                        предусмотрено федеральным законом.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">6. Цели обработки персональных данных</h2>
                    <p>
                        <span className="font-medium text-bark-800">Цель обработки:</span> предоставление доступа
                        Пользователю к сервисам, информации и/или материалам, содержащимся на веб-сайте.
                    </p>
                    <p className="font-medium text-bark-800">Персональные данные</p>
                    <ul className="list-disc space-y-1 pl-5">
                        <li>фамилия, имя, отчество;</li>
                        <li>электронный адрес;</li>
                        <li>номера телефонов.</li>
                    </ul>
                    <p className="font-medium text-bark-800">Правовые основания</p>
                    <p>договоры, заключаемые между оператором и субъектом персональных данных.</p>
                    <p className="font-medium text-bark-800">Виды обработки персональных данных</p>
                    <ul className="list-disc space-y-1 pl-5">
                        <li>сбор, уточнение, использование персональных данных;</li>
                        <li>отправка информационных писем на адрес электронной почты.</li>
                    </ul>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">7. Условия обработки персональных данных</h2>
                    <p>
                        7.1. Обработка персональных данных осуществляется с согласия субъекта персональных данных на
                        обработку его персональных данных.
                    </p>
                    <p>
                        7.2. Обработка персональных данных необходима для исполнения договора, стороной которого либо
                        выгодоприобретателем или поручителем по которому является субъект персональных данных, а
                        также для заключения договора по инициативе субъекта персональных данных или договора, по
                        которому субъект персональных данных будет являться выгодоприобретателем или поручителем.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">
                        8. Порядок сбора, хранения, передачи и других видов обработки персональных данных
                    </h2>
                    <p>
                        Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путём
                        реализации правовых, организационных и технических мер, необходимых для выполнения в полном
                        объёме требований действующего законодательства в области защиты персональных данных.
                    </p>
                    <p>
                        8.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры,
                        исключающие доступ к персональным данным неуполномоченных лиц.
                    </p>
                    <p>
                        8.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы
                        третьим лицам, за исключением случаев, связанных с исполнением обязательств по заключённому
                        между сторонами гражданско-правовому договору.
                    </p>
                    <p>
                        8.3. В случае выявления неточностей в персональных данных Пользователь может актуализировать
                        их самостоятельно, путём направления Оператору уведомления на адрес электронной почты
                        Оператора{' '}
                        <a className="text-pine-700 underline hover:no-underline" href={`mailto:${OPERATOR_EMAIL}`}>
                            {OPERATOR_EMAIL}
                        </a>{' '}
                        с пометкой «Актуализация персональных данных».
                    </p>
                    <p>
                        8.4. Срок обработки персональных данных определяется достижением целей, для которых были
                        собраны персональные данные, если иной срок не предусмотрен договором или действующим
                        законодательством. Пользователь может в любой момент отозвать своё согласие на обработку
                        персональных данных, направив Оператору уведомление посредством электронной почты на
                        электронный адрес Оператора{' '}
                        <a className="text-pine-700 underline hover:no-underline" href={`mailto:${OPERATOR_EMAIL}`}>
                            {OPERATOR_EMAIL}
                        </a>{' '}
                        с пометкой «Отзыв согласия на обработку персональных данных».
                    </p>
                    <p>
                        8.5. Вся информация, которая собирается сторонними сервисами, в том числе платежными
                        системами, средствами связи и другими поставщиками услуг, хранится и обрабатывается
                        указанными лицами (Операторами) в соответствии с их Пользовательским соглашением и Политикой
                        конфиденциальности. Субъект персональных данных и/или с указанными документами. Оператор не
                        несёт ответственность за действия третьих лиц, в том числе указанных в настоящем пункте
                        поставщиков услуг.
                    </p>
                    <p>
                        8.6. Установленные субъектом персональных данных запреты на передачу (кроме предоставления
                        доступа), а также на обработку или условия обработки (кроме получения доступа) персональных
                        данных, разрешённых для распространения, не действуют в случаях обработки персональных данных
                        в государственных, общественных и иных публичных интересах, определённых законодательством РФ.
                    </p>
                    <p>
                        8.7. Оператор при обработке персональных данных обеспечивает конфиденциальность персональных
                        данных.
                    </p>
                    <p>
                        8.8. Оператор осуществляет хранение персональных данных в форме, позволяющей определить
                        субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных,
                        если срок хранения персональных данных не установлен федеральным законом, договором, стороной
                        которого, выгодоприобретателем или поручителем по которому является субъект персональных
                        данных.
                    </p>
                    <p>
                        8.9. Условием прекращения обработки персональных данных может являться достижение целей
                        обработки персональных данных, истечение срока действия согласия субъекта персональных
                        данных, отзыв согласия субъектом персональных данных или требование о прекращении обработки
                        персональных данных, а также прекращение деятельности {OPERATOR_LEGAL_GENITIVE}.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">
                        9. Перечень действий, производимых Оператором с полученными персональными данными
                    </h2>
                    <p>
                        9.1. Оператор осуществляет сбор, уточнение (обновление, изменение), использование и
                        уничтожение персональных данных.
                    </p>
                    <p>
                        9.2. Оператор осуществляет неавтоматизированную обработку персональных данных с получением
                        и/или передачей полученной информации по информационно-телекоммуникационным сетям или без
                        таковой.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">
                        10. Трансграничная передача персональных данных
                    </h2>
                    <p>
                        10.1. Оператор до начала осуществления деятельности по трансграничной передаче персональных
                        данных обязан уведомить уполномоченный орган по защите прав субъектов персональных данных о
                        своём намерении осуществлять трансграничную передачу персональных данных (такое уведомление
                        направляется отдельно от уведомления о намерении осуществлять обработку персональных данных).
                    </p>
                    <p>
                        10.2. Оператор до подачи вышеуказанного уведомления обязан получить от органов власти
                        иностранного государства, иностранных физических лиц, иностранных юридических лиц, которым
                        планируется трансграничная передача персональных данных, соответствующие сведения.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">11. Конфиденциальность персональных данных</h2>
                    <p>
                        Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим
                        лицам и не распространять персональные данные без согласия субъекта персональных данных,
                        если иное не предусмотрено федеральным законом.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-semibold text-bark-900">12. Заключительные положения</h2>
                    <p>
                        12.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся
                        обработки его персональных данных, обратившись к Оператору с помощью электронной почты{' '}
                        <a className="text-pine-700 underline hover:no-underline" href={`mailto:${OPERATOR_EMAIL}`}>
                            {OPERATOR_EMAIL}
                        </a>
                        .
                    </p>
                    <p>
                        12.2. В данном документе будут отражены любые изменения политики обработки персональных данных
                        Оператором. Политика действует бессрочно до замены её новой версией.
                    </p>
                    <p>
                        12.3. Актуальная версия Политики в свободном доступе расположена в сети Интернет по адресу{' '}
                        <a
                            className="text-pine-700 underline hover:no-underline"
                            href={privacyPageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {privacyPageUrl}
                        </a>
                        .
                    </p>
                </section>
            </div>
        </div>
    );
};

export default Privacy;
